export default [
  {
    title: 'مدیریت اتاق جلسات',
    icon: 'BookOpenIcon',
    children: [
      {
        title: 'لیست درخواست اتاق',
        icon: 'LayersIcon',
        route: 'RoomReservation_AdminList',
        permission: 'room-reservations.admin.update',
      },
        {
        title: 'برنامه اتاق جلسات',
        icon: 'LayersIcon',
        route: 'RoomReservation_TimeSheet',
        permission: 'room-reservations.admin.update',
      },
      // {
      //   title: 'رزرو غذا',
      //   icon: 'SendIcon',
      //   route: 'Reservation',
      //   permission: 'reservations.index',
      // },
      //
      // {
      //   title: 'رزرو خاص',
      //   icon: 'ArchiveIcon',
      //   route: 'Reservation_Special',
      //   permission: 'special-reservations.index',
      // },
      //
      // {
      //   title: 'گزارشگیری',
      //   icon: 'ArchiveIcon',
      //   route: 'Reservation_Report',
      //   permission: 'reservations.report',
      // },

      {
        title: 'اتاق ها',
        icon: 'AirplayIcon',
        children: [
            {
                title: 'لیست اتاق ها',
                permission: 'rooms.index',
                route: 'Room_List',
            },
            {
                title: 'ایجاد اتاق',
                permission: 'rooms.store',
                route: 'Room_Create',
            },
        ]
      },

      {
        title: 'رزرو اتاق جلسات',
        icon: 'CastIcon',
        children: [
            {
                title: 'لیست درخواست اتاق من',
                permission: 'room-reservations.index',
                route: 'RoomReservation_List',
            },
            {
                title: 'درخواست اتاق جلسه',
                permission: 'room-reservations.store',
                route: 'RoomReservation_Create',
            },
        ]
      }
    ]
  }
]
